import React from 'react';

var Breadcrumb = React.createClass({
  handleClick: function(){
    sessionStorage.setItem("lib", this.props.libName);
  },
  render: function(){
    return(
       <div className="breadcrumb">
        <ul className="breadcrumb__list list-inline">
          <li className="breadcrumb__list--item"><a href="#">Design Library</a></li>
          <li className="breadcrumb__list--item" onClick = {this.handleClick}><a href="#">{this.props.libName}</a></li>
          <li className="breadcrumb__list--item"><span>{this.props.themeName}</span></li>
        </ul>
      </div>
    );
  }
});

export {Breadcrumb};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/Breadcrumb.jsx
 **/